export const REQUEST_START = 'REQUEST_START';
export const REQUEST_END = 'REQUEST_END';
export const API = 'API';
